import { createPropertySelectors, createSelector } from '@ngxs/store';

import { TableReservationsStateModel } from './table-reservation.model.state';
import { TableReservationsState } from './table-reservation.state';
import { DateHelper, ReservationHelper, TimeHelper } from 'src/app/helpers';
import {
  MealTime,
  ReservationMealConfiguration,
  ReservationTable,
  ReservationTimeSlotConfig
} from 'src/app/models';
import { LocationSelectors } from 'src/app/store/location/location.selectors';
import { TablesStateSelectors } from 'src/app/store/tables/tables.selectors';

export class TableReservationSelectors {
  static slices = createPropertySelectors<TableReservationsStateModel>(
    TableReservationsState
  );

  static reservations = createSelector(
    [TableReservationSelectors.slices.reservations],
    (reservations) => reservations
  );

  static dinerSearchReservations = createSelector(
    [TableReservationSelectors.slices.dinerSearchReservations],
    (dinerSearchReservations) => dinerSearchReservations
  );

  static reservationViewFocus = createSelector(
    [TableReservationSelectors.slices.reservationViewFocus],
    (reservationViewFocus) => reservationViewFocus
  );

  // static getReservationTables = createSelector(
  //   [TableReservationSelectors.reservations],
  //   (reservations) => {
  //     try {
  //       return reservations
  //         .reduce(
  //           (prev, curr) =>
  //             prev.concat(
  //               curr.reservation_tables.map((table) =>
  //                 ReservationHelper.modifyReservationTable(table, curr)
  //               )
  //             ),
  //           [] as ReservationTable[]
  //         )
  //         .sort((a, b) => {
  //           const aDateTime = DateHelper.parse(a.local_attrs.date);
  //           const aStartTime = TimeHelper.getPosTime(a.local_attrs.start_time);
  //           const bDateTime = DateHelper.parse(b.local_attrs.date);
  //           const bStartTime = TimeHelper.getPosTime(b.local_attrs.start_time);
  //           aDateTime.setHours(aStartTime.hour, aStartTime.minute);
  //           bDateTime.setHours(bStartTime.hour, bStartTime.minute);

  //           return aDateTime.getTime() - bDateTime.getTime();
  //         });
  //     } catch (ex) {
  //       console.log('Exception: ', ex);
  //       return [];
  //     }
  //   }
  // );

  static getConfigByDate = createSelector(
    [LocationSelectors.reservation_meal_configurations],
    (reservationMealConfigurations) => (date: string) => {
      let targetConfigurations: ReservationMealConfiguration[] = [];

      if (reservationMealConfigurations.length === 3) {
        targetConfigurations = reservationMealConfigurations;
      } else {
        const day = ReservationHelper.getReservationDay(date);

        targetConfigurations = reservationMealConfigurations.filter(
          (config) => config.day === day
        );
      }

      const timeSlotConfig: ReservationTimeSlotConfig = {
        startTime: '00:00',
        endTime: '23:59'
      };

      targetConfigurations.forEach((config) => {
        switch (config.meal_id) {
          case MealTime.Breakfast: {
            timeSlotConfig.breakfast = {
              startTime: config.start_time,
              endTime: config.end_time,
              max_capacity_total: config.max_capacity_total,
              total_number_of_seats: config.total_number_of_seats,
              default_reservation: config.default_reservation
            };
            return;
          }
          case MealTime.Lunch: {
            timeSlotConfig.lunch = {
              startTime: config.start_time,
              endTime: config.end_time,
              max_capacity_total: config.max_capacity_total,
              total_number_of_seats: config.total_number_of_seats,
              default_reservation: config.default_reservation
            };
            return;
          }
          case MealTime.Dinner: {
            timeSlotConfig.dinner = {
              startTime: config.start_time,
              endTime: config.end_time,
              max_capacity_total: config.max_capacity_total,
              total_number_of_seats: config.total_number_of_seats,
              default_reservation: config.default_reservation
            };
            return;
          }
          default:
            return;
        }
      });

      return timeSlotConfig;
    }
  );

  static getTimeSlotsByDate = createSelector(
    [
      TableReservationSelectors.getConfigByDate,
      TableReservationSelectors.reservations,
      TablesStateSelectors.getDiagramTables
    ],
    (config, reservations, tables) => (date: string) =>
      ReservationHelper.generateTimeSlots(
        config(date),
        reservations,
        tables,
        date
      )
  );

  // move from table-reservation.selectors.ts
  static getReservationTables = createSelector(
    [TableReservationSelectors.reservations],
    (reservations) => {
      try {
        return reservations
          .reduce(
            (prev, curr) =>
              prev.concat(
                curr.reservation_tables.map((table) =>
                  ReservationHelper.modifyReservationTable(table, curr)
                )
              ),
            [] as ReservationTable[]
          )
          .sort((a, b) => {
            const aDateTime = DateHelper.parse(a.local_attrs.date);
            const aStartTime = TimeHelper.getPosTime(a.local_attrs.start_time);
            const bDateTime = DateHelper.parse(b.local_attrs.date);
            const bStartTime = TimeHelper.getPosTime(b.local_attrs.start_time);
            aDateTime.setHours(aStartTime.hour, aStartTime.minute);
            bDateTime.setHours(bStartTime.hour, bStartTime.minute);

            return aDateTime.getTime() - bDateTime.getTime();
          });
      } catch (ex) {
        console.log('Exception: ', ex);
        return [];
      }
    }
  );

  // move from table-reservation.selectors.ts
  static getReservationById = createSelector(
    [TableReservationSelectors.reservations],
    (reservations) => (id: number) => reservations.find((r) => r.id === id)
  );

  // move from table-reservation.selectors.ts
  static getReservationsByDateAndStartTime = createSelector(
    [TableReservationSelectors.reservations],
    (reservations) => (date: string, start_time: string) =>
      reservations.filter(
        (reservation) =>
          reservation.date === date && reservation.start_time === start_time
      )
  );
}
